import Menu from "aldoo-ra/Menu"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import useSitePlatform from "@components/Site/useSitePlatform"

export default function ProductPostPurchase({ item, onAction }) {
  const [platform, setPlatform] = useSitePlatform()

  return (
    <div className="flex flex-col items-center justify-center">
      <Typography
        variant="body_18"
        className="text-text/70 mb-4">
        {item.message || "Explore the Aqua Mail features"}
      </Typography>

      {/* Features button with outlined/secondary style */}
      <Menu
        menuData={item?.actions[0]}
        renderAs="hlist"
        itemsAsLinks={false}
        onItemClick={onAction}
        menuItemRender={(item) => {
          const url =
            (item?.link[0]?.parameters &&
              item?.link[0]?.parameters[platform]) ||
            item?.link[0]?.url
          return (
            <Button variant="secondary_s">
              <a href={url}>{item?.label}</a>
            </Button>
          )
        }}
      />
    </div>
  )
}
